import React, { useState } from "react";
import "@/App.css";
import { AgeGate } from "./components/site/AgeGate";
import { Nav, WarningBanner } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { About } from "./components/site/About";
import { Products } from "./components/site/Products";
import { Orders } from "./components/site/Orders";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { PolicyModal } from "./components/site/PolicyModal";

function App() {
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [policy, setPolicy] = useState(null);

  return (
    <div className="App min-h-screen bg-misty-base text-misty-text" data-testid="app-root">
      <AgeGate open={!ageConfirmed} onConfirm={() => setAgeConfirmed(true)} />
      <WarningBanner />
      <Nav />
      <main data-testid="main-content">
        <Hero />
        <About />
        <Products />
        <Orders />
        <Contact />
      </main>
      <Footer onOpenPolicy={setPolicy} />
      <PolicyModal policyKey={policy} onClose={() => setPolicy(null)} />
    </div>
  );
}

export default App;
